<template>
  <v-card
    class="ma-0 inline-form"
    flat
    color="white"
  >
    <ValidationObserver
      ref="observer"
      v-slot="{ handleSubmit }"
    >
      <v-form
        ref="form"
        @submit.prevent="handleSubmit(submit)"
        v-model="valid"
      >
        <v-container
          fluid
          class="pa-0"
        >
          <v-row
            v-for="(modelRow, index) in model"
            :key="index"
            align="center"
          >
            <v-col
              v-for="(field, key, fieldIndex) in formFields"
              :key="`${index}-${key}`"
              v-bind="field.col || {cols: 4}"
            >
              <inline-form-field
                v-bind="cleanFieldSchema(field)"
                v-model="model[index][field.id]"
                @autoContinue="onAutoContinue"
                :type="field.type"
                :name="field.name || field.title"
                :title="field.title"
                :choices="field.choices"
                :clear-button="isLastField(fieldIndex)"
                :clear-button-title="deleteButtonTitle"
                :clear-button-action="deleteRow(index)"
                :auto-continue="autoContinue"
                isInlineFormField
              >
              </inline-form-field>
            </v-col>
          </v-row>
          <v-btn
            text
            @click="addFormRow"
            class="add-inline-row-btn"
          >
            <v-icon color="primary" left>mdi-plus-circle</v-icon>
            {{ addButtonTitle }}
          </v-btn>
        </v-container>
      </v-form>
    </ValidationObserver>
    <div v-if="!formFields">
      <h5>Please fix you JSON scheme</h5>
    </div>
  </v-card>
</template>

<script>
  import { _ } from 'vue-underscore';
  import {ValidationObserver} from "vee-validate";
  import {ComponentWithModelMixin} from "../../mixins/FlowGenerator";

  export default {
    name: "InlineForm",
    components: {
      'inline-form-field': () => import('../FlowGenerator/FlowField'),
      ValidationObserver,
    },
    mixins: [
      ComponentWithModelMixin
    ],
    props: {
      formFields: {
        type: Object,
        required: true
      },
      addButtonTitle: {
        type: String,
        default: "Add"
      },
      deleteButtonTitle: {
        type: String,
        default: "Remove"
      },
      addInitialRow: {
        type: Boolean,
        default: false
      },
      autoContinue: {
        type: Boolean,
        default: false,
        description: "If true onBlur event of this field will send autoContinue event into FlowPreview",
      },
    },
    computed: {
      cleanFieldSchema() {
        return field => _.omit(field, 'col')
      },
      modelObject() {
        return _.mapObject(this.formFields, () => undefined)
      }
    },
    mounted() {
      if (this.addInitialRow) {
        this.addFormRow()
      }
    },
    data() {
      return {
        valid: false,
        model: [],
        rows: 0
      }
    },
    methods: {
      // use it to run current form validation
      // from parent component manually and
      // to get answer about a status
      async validate(silent = false) {
        this.valid = await this.$refs.observer.validate({silent});
        return this.valid
      },
      deleteRow(rowIndex) {
        return () => this.model.splice(rowIndex, 1);
      },
      addFormRow() {
        if (!this.model) {
          this.model = []
        }
        this.model.push({...this.modelObject})
      },
      isLastField(index) {
        return _.keys(this.formFields).length === (index +1)
      },
      onAutoContinue() {
        this.$emit('autoContinue')
      }
    },
    watch: {
      'model': function (val) {
        this.emitter(val);
      }
    }
  }
</script>
